/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_SettingsInputs */

const en_notification_settings = /** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Settings`)
};

const id_notification_settings = /** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan Notifikasi`)
};

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const es_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const fr_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const de_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const ja_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const zh_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const ar_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const it_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const ru_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const pt_notification_settings = en_notification_settings;

/** @type {(inputs: Notification_SettingsInputs) => LocalizedString} */
const ko_notification_settings = en_notification_settings;

/**
* | output |
* | --- |
* | "Notification Settings" |
*
* @param {Notification_SettingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const notification_settings = /** @type {((inputs?: Notification_SettingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_SettingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notification_settings(inputs)
	if (locale === "es") return es_notification_settings(inputs)
	if (locale === "fr") return fr_notification_settings(inputs)
	if (locale === "de") return de_notification_settings(inputs)
	if (locale === "ja") return ja_notification_settings(inputs)
	if (locale === "zh") return zh_notification_settings(inputs)
	if (locale === "ar") return ar_notification_settings(inputs)
	if (locale === "id") return id_notification_settings(inputs)
	if (locale === "it") return it_notification_settings(inputs)
	if (locale === "ru") return ru_notification_settings(inputs)
	if (locale === "pt") return pt_notification_settings(inputs)
	return ko_notification_settings(inputs)
});